import Vue from 'vue';
import VueI18n from 'vue-i18n';
import * as axios from '@/axios';

import cn from './lang/cn';
import en from './lang/en';
import tw from './lang/tw';
import idn from './lang/idn';
import { isSingleCoin, currencyMessages } from './currency';
// import thai from './lang/thai'
import { LocalStorageEventName } from '@/script/localStorage';
import { Locale } from 'vant';
// 引入英文语言包
import enUS from 'vant/es/locale/lang/en-US';
import zhCN from 'vant/es/locale/lang/zh-CN';
import zhTW from 'vant/es/locale/lang/zh-TW';
import trTR from './lang/vant-idn';

// Locale.use('en-US', enUS);

Vue.use(VueI18n);
const languageConfig = {
  '1': {
    language: 'cn',
    languageCode: '1',
    languageName: '中文',
    languageUrl: 'https://data.nicee.app/api/language/cn',
    message: undefined
  },
  '2': {
    language: 'tw',
    languageCode: '2',
    languageName: '中文繁體',
    languageUrl: 'https://data.nicee.app/api/language/tw',
    message: undefined
  },
  '3': {
    language: 'en',
    languageCode: '3',
    languageName: 'English',
    languageUrl: 'https://data.nicee.app/api/language/en',
    message: undefined
  },
  '5': {
    language: 'idn',
    languageCode: '5',
    languageName: 'Bahasa Indonesia',
    languageUrl: 'https://data.nicee.app/api/language/id',
    message: undefined
  }
};
const getValidLanguageCode = (languageCode, fallback = '2') => {
  const code = String(languageCode || '');
  return languageConfig[code] ? code : fallback;
};
const getAppLanguageCode = () =>
  getValidLanguageCode(
    localStorage.getItem(LocalStorageEventName.deviceLanguage),
    ''
  );
const getLocalLanguageCode = () =>
  getValidLanguageCode(
    getAppLanguageCode() ||
      localStorage.getItem(LocalStorageEventName.language) ||
      '2'
  );
const languageCode = getLocalLanguageCode();
console.log(
  'languageConfig[languageCode].language',
  languageConfig[languageCode].language
);
function setVantLocale(languageCode) {
  if (languageCode == '1') {
    Locale.use('zh-CN', zhCN);
  }
  if (languageCode == '2') {
    Locale.use('zh-TW', zhTW);
  }
  if (languageCode == '3') {
    Locale.use('en-US', enUS);
  }
  // 因為vant沒有印度尼西亞語，將土耳其語修改為印度尼西亞語
  if (languageCode == '5') {
    // const messages = {
    //   'tr-TR': {
    //     cancel: i18n.t('home_cancel')
    //   }
    // };
    Locale.use('tr-TR', trTR);
    // Locale.add(messages);
  }
}
setVantLocale(languageCode);
const i18n = new VueI18n({
  locale: languageConfig[languageCode].language || 'tw',
  messages: isSingleCoin
    ? currencyMessages({ cn, en, tw, idn })
    : { cn, en, tw, idn },
  fallbackLocale: 'tw'
});

// 设置多语言
async function getLanguage(remoteLanguageCode, options = {}) {
  try {
    if (options.source === 'backend' && getAppLanguageCode()) {
      return false;
    }
    let languageCode = getValidLanguageCode(
      remoteLanguageCode || getLocalLanguageCode()
    );
    // 业务暂时不需要从接口获取语言吧，所以注释掉  
    // if (!languageConfig[languageCode].message) {
    //   const url = languageConfig[languageCode].languageUrl;
    //   const language = languageConfig[languageCode].language;
    //   const { lan } = await axios.get(url);
    //   for (let item of lan) {
    //     for (const i in item) {
    //       if (!item[i]) {
    //         delete item[i];
    //       }
    //     }
    //   }
    //   languageConfig[languageCode].message = lan;
    //   let message = {};
    //   lan.forEach(element => {
    //     message = Object.assign(message, element);
    //   });
    //   i18n.mergeLocaleMessage(language, message);
    //   console.log(i18n.messages.tw);
    // }
    i18n.locale = languageConfig[languageCode].language;
    localStorage.setItem(LocalStorageEventName.language, languageCode);
    setVantLocale(languageCode);
    return true;
  } catch (error) {
    console.log(error);
  }
}
export { getAppLanguageCode, getLanguage };
export default i18n;
